import React from 'react';
import {apiV2TransactionsList} from '../../../../api/merchant/transactions';

import {TableMerchant} from '../../../helpers/Table/';
import {generateActionsList} from "./utils/generateActionsList";
import {columnsList} from "./constants/columnsList";
import {reportGenerationParams} from "./constants/reportGenerationParams";
import {statuses, transactionTypes} from "../../../dumb/IntervalFilterCustom";
import {Box} from "@material-ui/core";
import handleDBItemData from "./utils/handleDBItemData";
import {MerchantPageHeader} from "../../../helpers/Display";

const getRowsFromServer = ({offset, limit, ...rest}) => {
  return apiV2TransactionsList({offset, limit, ...rest}).then((res) => {
    res.list = res.list.map(handleDBItemData);
    return res;
  });
};

module.exports = () => {
  return (
    <>
      <MerchantPageHeader title="Transactions" />
      <Box width="100%" height="calc(100% - 50px)" minHeight="500px">
        <TableMerchant
          filtersParams={{
            selects: {
              transactionKind: transactionTypes,
              status: statuses
            }
          }}
          getDataFromServer={getRowsFromServer}
          report={reportGenerationParams}
          columns={columnsList}
          actions={(row, update) => (
            generateActionsList(row, update)
          )}
        />
      </Box>
    </>
  )
}
